import { useTranslation } from "react-i18next";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

import f1 from "../../assets/foto/hero-1.jpg";
import f2 from "../../assets/foto/hero-2.jpg";

const images = [f1, f2];

function Hero() {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
    },
    [
      Autoplay({
        delay: 4000,
        stopOnInteraction: false,
      }),
    ],
  );

  const { t } = useTranslation();

  return (
    <section id="hero" className="hero-section">
      <div className="hero-grid">
        <div className="hero-content">
          <h1 className="hero-title">{t("hero.title")}</h1>
          <p className="hero-paragraph">
            Nelle nostre sale i maestri formano i campioni.
          </p>
          <p className="hero-paragraph">
            Nei nostri accampamenti i rievocatori rivivono la storia
          </p>
          <a href="#contatti" className="base-button">
            {t("hero.contactUs")}
          </a>
        </div>
        <div className="overflow-hidden rounded-2xl" ref={emblaRef}>
          <div className="flex">
            {images.map((image, index) => (
              <div key={index} className="min-w-0 flex-[0_0_100%]">
                <img
                  src={image}
                  alt={`carousel ${index + 1}`}
                  className="aspect-[4/3] w-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
